<script lang="ts" setup>
import { useAccordion } from './useAccordion';
import { useSharedState } from 'composables/useSharedState';
useSharedState<{}>({});
const accordion = useAccordion();
</script>

<template>
  <button
    type="button"
    class="e-accordion-trigger"
    @click="accordion.toggle()"
  >
    <slot />
  </button>
</template>
